import React, { useEffect, useState } from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import PageHeader from 'components/common/PageHeader';
import { useQuery } from "@tanstack/react-query";
import { getHorses } from "../data/Querys";
import NotAvailable from "../components/common/NotAvailable";
import Loader from "../components/general/Loader";
import { Stack } from "react-bootstrap";
import SelectorNoc from "../components/common/selectors/selector-noc";
import HorsesTable from "../components/common/participants/HorsesTable";
import { ALL_URL, SELECTOR_DISPLAY_TYPE } from 'helpers/utils';
import { useLabels } from 'components/general/Label';


export default function Horses() {
    const [nameFilter, setNameFilter] = useState('');
    const [dataState, setDataState] = React.useState([]);
    const { mirs_competition, mirs_language, mirs_noc } = useUrlFriendlyToParameters()
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'LabelSearch' });

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['horses', mirs_competition, mirs_language],
            queryFn: getHorses,
            refetchInterval: 0
            //staleTime: 5000,
            //refetchIntervalInBackground: true
        });

    useEffect(() => {
        let filterData = data?.horses
        filterData = filterData?.filter(item => item?.discipline?.code === 'EQU');
        if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC)
            filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        if (nameFilter) {
            filterData = filterData?.filter(item => item?.name?.toLowerCase().includes(nameFilter?.toLowerCase()));
        };
        setDataState(filterData);
    }, [data, mirs_noc, nameFilter]);

    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.horses) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }

    const handleOnChange = event => {
        const { name, value } = event.target;
        let val = value;
        val = val.trimEnd();
        setNameFilter(val);
    };


    return (
        <>
            <PageHeader title='Horses' />
            <div className='mirs-page-container'>
                <Stack direction="horizontal" className='selectors-container'>
                    <SelectorNoc display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="horses" />
                    <div className="d-flex competitor-search">
                        {/*<label htmlFor="city"><Label data={"HeaderNOC"} /></label>*/}
                        <input type="text" className="form-control" name="Search" id="Search"
                            placeholder={placeholder}
                            onChange={handleOnChange} />
                    </div>
                </Stack>
                <div>
                    {dataState && <HorsesTable data={dataState} key={`horses`} />}
                </div>
            </div>
        </>
    )
};